module.exports = __webpack_public_path__ + "img/logo.89e1d42e.png";